import React from 'react';
import { Card, Row, Col, Divider } from 'antd';
import { TInformTextItem } from '../types/TInformText';
import EmblemImage from '../assets/Emblem_of_Kazakhstan_latin 1.png';
import { localize } from 'mixins/helpers';

interface Props {
  title: string;
  image: string;
  imageTitle: string;
  textListItems: TInformTextItem[],
  translations:  Record<string, string>,
}

const QrComponent: React.FC<Props> = ({ title, image, imageTitle, textListItems, translations }) => {
  
  const text_call_center = localize('call-center', translations).split('1414');
  
  return (
    <div className="qr-component">
      <Row>
        <Col
          md={24}
          className="qr-component__title"
        >
          <img src={EmblemImage}></img>
          <h3>{title}</h3>
        </Col>
      </Row>
      <Row gutter={{ xs: 10, md: 22 }}>
        <Col md={12}>
          <Card
            bordered={false}
            cover={
              <img
                alt={localize('qr-code', translations)}
                src={image}
              />
            }
          >
            <h3>{imageTitle}</h3>
          </Card>
        </Col>
        <Col md={12}>
          <div className="qr-component__text">
            <ul className="qr-component__list">
              {textListItems.map((element) => {
                return (
                  <li>
                    {element.image}
                    <div>{element.text}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          md={24}
          className="qr-component__footer"
        >
          <section>
            {text_call_center[0]}
            <a href="tel:1414">1414</a>&nbsp;
            {text_call_center[1]}
          </section>
        </Col>
      </Row>
    </div>
  );
};

export default QrComponent;
